import * as React from 'react';
export const stripeSvg = React.forwardRef(function stripeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#533AFD',
      d: 'M0 .002h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm8 24 16-3.393V8L8 11.433V24Z',
      fill: '#fff',
    }),
  );
});
stripeSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var stripe = {
  category: 'brand',
  colorable: false,
  name: 'stripe',
  svg: stripeSvg,
};
